<template>
  <v-row>
    <v-col cols="12" v-if="back_on">
      <v-btn
        @click="$router.go(-1)"
        rounded
        color="secondary"
        depressed
        :block="isMobile()"
      >
        <v-icon left>mdi-arrow-left</v-icon> Voltar</v-btn
      >
    </v-col>
    <v-col cols="12">
      <v-card flat>
        <v-card-title class="font-weight-bold"
          >Atualizar Dados Pessoais</v-card-title
        >
        <v-card-text>
          <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
          <template v-else>
            <v-form ref="form">
              <v-select
                label="Etnia/Raça"
                :items="racas"
                item-text="descricao"
                item-value="codigo"
                no-data-text="Nenhuma opção disponível"
                v-model="dadosCadastrais.cutis"
                placeholder="Selecione sua etnia/raça"
                persistent-placeholder
                :rules="[(v) => !!v || 'Informação obrigatória']"
              ></v-select>
            </v-form>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                rounded
                block
                depressed
                color="success"
                @click="atualizarDadosPessoais()"
                :loading="atualizando"
                v-show="!loading"
                >Confirmar dados</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
export default {
  props: {
    back_on: {type: Boolean, default: true}
  },
  computed: mapState("atualizacaoCadastral", ["racas", "dadosCadastrais"]),
  data: () => ({
    loading: true,    
    atualizando: false,
  }),
  methods: {
    ...mapActions("atualizacaoCadastral", ["getRacas", "getDadosCadastrais"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async atualizarDadosPessoais() {
      if (this.$refs.form.validate()) {
        this.atualizando = true;

        await axios
          .post(
            "/colaborador/atualizacao-cadastral",
            JSON.stringify(this.dadosCadastrais),
            {
              params: {
                funcao: "ATUALIZAR-DADOS-PESSOAIS",
              },
            }
          )
          .then((res) => {
            if (res.data.success) {
              this.$toasted.success(res.data.msg);
              this.$router.go()
            } else this.$toasted.error(res.data.msg);
          })
          .catch((e) => {
            this.$toasted.error(e);
          });

        this.atualizando = false;
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getRacas();
    await this.getDadosCadastrais();
    this.loading = false;
  },
};
</script>

<style>
</style>